var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#2450ff;}.c{fill:#069de5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-690 -1065)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(690 1065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7598-1546a14.9,14.9,0,0,1-10.606-4.393A14.9,14.9,0,0,1-7613-1561h30a14.9,14.9,0,0,1-4.394,10.607A14.9,14.9,0,0,1-7598-1546Z",
    transform: "translate(8318 2661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7597-1575h-2a3.977,3.977,0,0,0-1.172-2.828A3.971,3.971,0,0,0-7603-1579a4.006,4.006,0,0,0-4,4l-2,0a6.008,6.008,0,0,1,6-6,6.006,6.006,0,0,1,6,6l0,0Z",
    transform: "translate(8313 2666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-7597-1575h-2a3.977,3.977,0,0,0-1.172-2.828A3.971,3.971,0,0,0-7603-1579a4.006,4.006,0,0,0-4,4l-2,0a6.008,6.008,0,0,1,6-6,6.006,6.006,0,0,1,6,6l0,0Z",
    transform: "translate(8333 2666)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(704 1090)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(724 1090)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(714 1090)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(734 1090)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(732 1065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-5696-134a8.962,8.962,0,0,1,1.934-5.575,30.137,30.137,0,0,1,12.64,12.64A8.959,8.959,0,0,1-5687-125,9,9,0,0,1-5696-134Z",
    transform: "translate(6428 1208)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.da6217c8f19433bf32017bd698bcc591.svg";
export { ForwardRef as ReactComponent };